import { useEffect, useState } from 'react';
import { filter } from '../../../pages/fleet-calculator/copy';
import useSettingsStore from '../store/settings-store';

const Fuel = () => {
  const { updateSettingsStore, electricityPricePerKwh, gasPricePerLiter } =
    useSettingsStore();
  const [electricFuelCost, setElectricFuelCost] = useState(
    String(electricityPricePerKwh),
  );
  const [gasFuelCost, setGasFuelCost] = useState(String(gasPricePerLiter));

  useEffect(() => {
    updateSettingsStore({
      electricityPricePerKwh: Number(electricFuelCost),
    });
  }, [electricFuelCost]);

  useEffect(() => {
    updateSettingsStore({
      gasPricePerLiter: Number(gasFuelCost),
    });
  }, [gasFuelCost]);

  return (
    <>
      <div className="flex flex-col gap-2 relative">
        <label htmlFor="electric-fuel-cost">{filter.fuelCostElectric}</label>
        <div className="relative">
          <input
            id="electric-fuel-cost"
            value={electricFuelCost}
            type="number"
            className="py-4 pl-4 pr-10 w-full rounded-[2px] border border-black ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-visible:outline-none"
            onChange={(e) => {
              setElectricFuelCost(e.target.value);
            }}
          />
          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
            kr/kWh
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-2 relative">
        <label htmlFor="fuel-cost">{filter.fuelCost}</label>
        <div className="relative">
          <input
            id="fuel-cost"
            value={gasFuelCost}
            type="number"
            className="py-4 pl-4 pr-10 w-full rounded-[2px] border border-black ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-visible:outline-none"
            onChange={(e) => {
              setGasFuelCost(e.target.value);
            }}
          />
          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
            kr/liter
          </span>
        </div>
      </div>
    </>
  );
};

export default Fuel;
